import React from "react";
import { useNavigate } from "react-router-dom";
import { ActionCell } from "..";
import { IMeal } from "../../../common/types";
import { deleteMealInFirestore } from "../../../firestore/firestoreService";
import { Table } from "../../atoms";
import { MealWrapper } from "./Meal.style";

interface IMealListProps {
  meals: IMeal[];
  loading: boolean;
}
export const MealList: React.FC<IMealListProps> = ({ meals, loading }) => {
  const history = useNavigate();
  const handelDeleteMeal = async (id: string) => {
    await deleteMealInFirestore(id);
  };
  const handelEditMeal = (id: string) => () => {
    history(`/setting/meal/${id}`);
  };
  const columnsList = [
    {
      title: "Meal name",
      dataIndex: "name",
      key: "name",
      render: (v: string, record: IMeal) => v || "",
    },
    {
      title: "Price Adult",
      dataIndex: "adultPrice",
      key: "adultPrice",
      render: (v: string) => `€ ${v || "-"}`,
    },
    {
      title: "Price Child",
      dataIndex: "childPrice",
      key: "childPrice",
      render: (v: string) => `€ ${v || "-"}`,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 30,
      render: (v: any, record: IMeal) => (
        <ActionCell
          onDelete={() => handelDeleteMeal(record.id)}
          onEdit={handelEditMeal(record.id)}
        />
      ),
    },
  ];
  return (
    <MealWrapper>
      <Table
        columns={columnsList}
        dataSource={meals}
        loading={loading}
        rowKey="id"
        pagination={{
          pageSize: 20,
        }}
        // scroll={{ x: 800, y: 500 }}
      />
    </MealWrapper>
  );
};
